import { IFileSaver } from '@/contracts/core/file/IFileSaver'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import FileSaverV1 from '@/core/file/v1/FileSaverV1'

const version = 'v1'

class FileSaverProvider extends Provider<IFileSaver> {
  realizations: Record<string, IFileSaver> = {
    v1: FileSaverV1(),
  }
}

const instance: { module: IFileSaver | null } = { module: null }

export function FileSaverProviderModule(): IFileSaver {
  if (!instance.module) {
    instance.module = new FileSaverProvider().module(version)
  }

  return instance.module
}
